import React, { useMemo } from 'react';
import { Container, ProgrammingLanguage } from '../../../../../symphony';
import { SlDataService } from '../../../services/sl-data.service';
import { useContainerData } from '../../../../../shared/public/SlHooks/useContainerData';
import { ProgrammingLanguageToCodeLanguages } from '../../../../../shared/public/constants/constants';
import { SlAISolutions } from '../../../../../kodie/public/SlAISolutions/SlAISolutions';
import { MaterialType } from '../../../../../api/private/learn-engine-api/learn-engine-api.interface';
import { lePlaygroundContext } from '../../../global-constants';

interface IAISolutionsProps {
	isTIYWidget?: boolean;
	isLightMode?: boolean;
}

export function AISolutions({ isTIYWidget, isLightMode }:IAISolutionsProps) {
	const {
		codeData$: codeData,
		sourceCode$: sourceCode,
		jsCode$: jsCode,
		cssCode$: cssCode,
		isWeb$: isWeb,
		materialData$: materialData,
	} = useContainerData(lePlaygroundContext.value, SlDataService, [
		'codeData$',
		'sourceCode$',
		'jsCode$',
		'cssCode$',
		'isWeb$',
		'materialData$',
	]);
	const isTryItYourself: boolean = Container.take(
		lePlaygroundContext.value,
		'isTryItYourself',
	);
	const solutionsData = useMemo(
		() => ({
			materialType: MaterialType.TryItYourself,
			materialHeader: materialData?.header,
			codes: isWeb
				? [
					...(jsCode
						? [
							{
								language: ProgrammingLanguage.Js,
								code: jsCode,
							},
						]
						: []),
					...(cssCode
						? [
							{
								language: ProgrammingLanguage.Css,
								code: cssCode,
							},
						]
						: []),
					...(sourceCode
						? [
							{
								language: ProgrammingLanguage.Html,
								code: sourceCode,
							},
						]
						: []),
				]
				: [
					{
						language: +Object.keys(
							ProgrammingLanguageToCodeLanguages,
						).find(
							(item) => ProgrammingLanguageToCodeLanguages[item]
                                  === codeData?.language,
						),
						code: sourceCode,
					},
				],
		}),
		[jsCode, cssCode, sourceCode, codeData?.language],
	);

	return isTryItYourself && codeData ? (
		<SlAISolutions isTIYWidget={isTIYWidget} isLightMode={isLightMode} solutionsData={solutionsData} />
	) : null;
}
